import { put, call, select, takeLatest } from 'redux-saga/effects';
import * as actions from './actions';
import { Endpoints } from 'services/api';
import errorHandler from 'common/errorHandler';

const getTenant = (state) => state.userLogin.tenant;

function* getUserEvents(api, tenantId, userId) {
    let result = yield call([api, api.get], `${Endpoints.events}/api/v1/users/${userId}/events`, { tenantid: tenantId });
    return result.data;
}

export function* getUserEventsRequest(api, { userId }) {
    try {
        let tenant = yield select(getTenant);
        let userEventsResult = yield call(getUserEvents, api, tenant.tenantId, userId);
        yield put(actions.getUserEventsSuccess(userEventsResult));
    } catch (error) {
        let errorObject = errorHandler(error, "Get", "user events");
        yield put(actions.getUserEventsFailure(errorObject));
    }
}

export function* watchGetUserEventsRequest(api, { params }) {
    yield call(getUserEventsRequest, api, params);
}

export default function* ({ api }) {
    yield takeLatest(actions.GET_USER_EVENTS_REQUEST, watchGetUserEventsRequest, api);
}